export const PADDING = 0.05;
export const MIN_SCALE = 0.5;
export const MAX_SCALE = 9;
// Custom scale factor for zooming based on document type
export const SF_PDF = 1.15;
export const SF_IMG = 1.12;
